import { apiConfig } from '@/services/api-config';

export const getAgentByDocument = async (tokenKey: string, document: string) => apiConfig
  .get(`api/Agent/get-agent-by-document?tokenKey=${tokenKey}&document=${document}`)
  .then((response) => response.data)
  .catch(() => []);
